import "./controls.css";
import React, { useState, useEffect } from "react";

import { Radio, Card, Slider } from "antd";

const marks = {
  0: "0%",
  100: "100%"
};

export const Controls = ({ onSelect, videoWidth }) => {
  const [daltonism, setDaltonism] = useState("1");
  const [intensity, setIntensity] = useState(100);

  useEffect(() => {
    onSelect({ daltonism: Number(daltonism), intensity: intensity / 100 });
  }, [intensity, daltonism, onSelect]);

  return (
    <>
      <div className="ctrls ctrls--mobile">
        <Card>
          <div style={{ textAlign: "center" }}>
            <Radio.Group
              size="small"
              defaultValue="0"
              value={daltonism}
              style={{ margin: "0 auto" }}
              onChange={e => setDaltonism(e.target.value)}
            >
              <Radio.Button value="1">Protanotopia</Radio.Button>
              <Radio.Button value="2">Deuteranotopia</Radio.Button>
              <Radio.Button value="3">Tritanotopia</Radio.Button>
            </Radio.Group>
          </div>
          <Slider
            min={0}
            max={100}
            step={1}
            marks={marks}
            value={intensity}
            onChange={setIntensity}
            disabled={daltonism === 0}
            style={{ marginTop: "18px", marginBottom: "8px" }}
          />
        </Card>
      </div>

      <div
        className="ctrls ctrls--desktop"
        style={{ margin: "0 auto", width: videoWidth }}
      >
        <Card>
          <div style={{ textAlign: "center" }}>
            <Radio.Group
              size="large"
              defaultValue="0"
              value={daltonism}
              style={{ margin: "0 auto" }}
              onChange={e => setDaltonism(e.target.value)}
            >
              <Radio.Button value="1">Protanotopia</Radio.Button>
              <Radio.Button value="2">Deuteranotopia</Radio.Button>
              <Radio.Button value="3">Tritanotopia</Radio.Button>
            </Radio.Group>
          </div>
          <Slider
            min={0}
            max={100}
            step={1}
            marks={marks}
            value={intensity}
            onChange={setIntensity}
            disabled={daltonism === 0}
          />
        </Card>
      </div>
    </>
  );
};
